import type { FlightDataViewerDb } from './db';
import { db as defaultDb } from './db';

/**
 * Empty every table — the factory reset behind Settings' reset control.
 *
 * Clears the tables rather than calling `Dexie.delete()`. Deleting the database
 * blocks while any other connection is open, which on a browser with the app in
 * a second tab means the reset never resolves and the pilot is left staring at a
 * disabled button. Clearing needs no exclusive lock, leaves the schema at the
 * version this build expects, and reaches the same end state: with the settings
 * table empty every `useSetting` falls back to `DEFAULT_SETTINGS`, and nothing
 * outside IndexedDB holds app state.
 *
 * `database.tables` is read from Dexie rather than listing the tables here, so a
 * table appended in a later migration cannot be missed by a reset that predates
 * it.
 */
export async function resetDatabase(database: FlightDataViewerDb = defaultDb): Promise<void> {
  const { tables } = database;
  await database.transaction('rw', tables, async () => {
    await Promise.all(tables.map((table) => table.clear()));
  });
}
